export default __webpack_public_path__ + "assets/d6459fa8de34af00f04ef3f0652d361e.svg";